import { CostCentersActionBar } from "./cost-centers-action-bar";
import { DataTable } from "./table";

export function CostCentersTable<TData, TValue>() {
  return (
    <div className="flex flex-col pb-4 gap-4">
      <div className="flex-1">
        <DataTable>
          <CostCentersActionBar />
        </DataTable>
      </div>
    </div>
  );
}
